import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FisioterapiaMusculoEsqueletica from './components/FisioterapiaMusculoEsqueletica';
import GoogleAnalytics from './components/GoogleAnalytics';

// Componente da página inicial
function HomePage() {
  const location = useLocation();

  useEffect(() => {
    // Verifica se há um hash na URL e faz scroll para o elemento correspondente
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  return (
    <main>
      <Hero />
      <About />
      <Services />
      <Contact />
    </main>
  );
}

function App() {
  return (
    <Router>
      <GoogleAnalytics measurementId="G-K8EVYXMY0Y" />
      <div className="min-h-screen bg-white">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/fisioterapia-musculo-esqueletica" element={<FisioterapiaMusculoEsqueletica />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
